import React, { useState } from 'react';
import { useMarketNavigate } from '../hooks/useMarketNavigate';
import { useMarket } from '../context/MarketContext';
import { useAuth } from '../context/AuthContext';
import './Login.css'; // Reuse login page styles

function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useMarketNavigate();
  const market = useMarket();
  const { getToken, refreshUser, user } = useAuth();

  const API_BASE = process.env.REACT_APP_API_URL || '';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match.');
      return;
    }

    if (newPassword.length < 8) {
      setError('New password must be at least 8 characters.');
      return;
    }

    if (currentPassword === newPassword) {
      setError('New password must be different from current password.');
      return;
    }

    setIsLoading(true);

    try {
      const token = getToken();
      const res = await fetch(`${API_BASE}/api/auth/change-password`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ currentPassword, newPassword }),
      });

      const data = await res.json();

      if (res.ok) {
        // Refresh user data (password_must_change will be cleared)
        await refreshUser();

        // Redirect to appropriate landing page
        const role = user?.role;
        if (role === 'super_admin' || role === 'admin') {
          navigate('/admin', { replace: true });
        } else if (role === 'venue_owner') {
          navigate('/admin/venue', { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      } else {
        setError(data.error || 'Failed to change password');
        setIsLoading(false);
      }
    } catch (err) {
      setError('Unable to connect to server');
      setIsLoading(false);
    }
  };

  const loginPageStyle = {
    '--market-primary': market.theme.primaryColor,
    '--market-accent': market.theme.accentColor,
  };

  return (
    <div className="login-page" style={loginPageStyle}>
      <div className="login-container">
        <header className="login-header">
          <img src={market.logo} alt={market.logoAlt} className="login-logo" />
          <h2 style={{ color: '#333', margin: '0.5rem 0' }}>Change Password</h2>
          <p className="login-subtitle">Please set a new password to continue.</p>
        </header>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="current-password">Current Password</label>
            <input
              type="password"
              id="current-password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Enter your current password"
              autoFocus
              autoComplete="current-password"
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="new-password">New Password</label>
            <input
              type="password"
              id="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="At least 8 characters"
              autoComplete="new-password"
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirm-password">Confirm New Password</label>
            <input
              type="password"
              id="confirm-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Re-enter new password"
              autoComplete="new-password"
              disabled={isLoading}
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? 'Updating...' : 'Update Password'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ChangePassword;
